module.exports = __webpack_public_path__ + "static/leader1-6680219c1bf02b8d711e2fe3e8155ca9.svg";